import type { StaticLayerPayload } from "@config";
import { TabsLibrary, TabsPdf } from "@library-combos/tabs";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: TabsLibrary,
  pdf: TabsPdf,
};

export const Tabs = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
